
import React, { createContext, useContext, ReactNode } from 'react';
import { useNavigationState } from '@/hooks/useNavigationState';

// Définir le type du contexte
type NavigationContextType = {
  currentPath: string;
  navigationHistory: string[];
  lastVisitedPage: string;
  goBack: () => void;
};

// Créer le contexte
const NavigationContext = createContext<NavigationContextType | undefined>(undefined);

// Provider component
export const NavigationProvider = ({ children }: { children: ReactNode }) => {
  const navigationState = useNavigationState();

  return (
    <NavigationContext.Provider value={navigationState}>
      {children}
    </NavigationContext.Provider>
  );
};

// Hook pour utiliser le contexte
export const useNavigation = (): NavigationContextType => {
  const context = useContext(NavigationContext);
  
  if (context === undefined) {
    throw new Error('useNavigation must be used within a NavigationProvider');
  }
  
  return context;
};
